import React, { Fragment } from 'react';
import { language } from 'Root/constants';
import Data from 'Content/content.json';
import Title from './Title';
import Unavailable from './Unavailable';
import Description from './Description';
import Disclaimer from './Disclaimer';

import './ProductTutorial.scss';

const ProductTutorial = ({ lookIndex, selectedLensType, lensIndex }) => {
  const lens = Data.data.productInfo[language][selectedLensType][lensIndex];
  const isAvailable = lens.availability > 0 ? true : false;

  return (
    <Fragment>
      <Title lookIndex={lookIndex} lensLongName={lens.long_name} lensName={lens.name} />
      {!isAvailable && <Unavailable />}
      {isAvailable && (
        <Fragment>
          {
            lens.specs.length>0 && (
              <Description lens={lens} selectedLensType={selectedLensType} />
            )
          }
          <Disclaimer lensIndex={lensIndex} />
        </Fragment>
      )}
    </Fragment>
  );
};

export default ProductTutorial;
